<template>
	<div>
       <loader :show="enviando"/>
        <v-container fluid>
            <v-layout row wrap>
                <v-flex xs12 md12>
                    <v-card class="elevation-10">
                        <v-toolbar >
                        <v-card-title><h3>Listado general de personal</h3></v-card-title>
                        </v-toolbar>

                        <v-card-title primary-title>
                            
                            <v-card>
                                <v-card-title>
                                    <v-tooltip v-if="puedeAgregar" top>
                                        <v-btn fab dark small color="primary" slot="activator" @click="nuevoPersonal()">
                                            <v-icon dark>fa-user-plus</v-icon>
                                        </v-btn>
                                        <span>Agregar</span>
                                    </v-tooltip>
                                    <v-spacer></v-spacer>
                                    <v-text-field
                                        v-model="buscar"
                                        append-icon="search"
                                        label="Search"
                                        single-line
                                        hide-details
                                    ></v-text-field>
                                </v-card-title>


                                <v-data-table
                                    :headers="lista.headers"
                                    :items="lista.data"
                                    :rows-per-page-items="tableProps.rows"
                                    :no-data-text="tableProps.noData"
                                    :no-results-text="tableProps.noResults"
                                    :rows-per-page-text="tableProps.rowsText"
                                    class="elevation-1"
                                    :search="buscar"
                                >
                                    <template slot="items" slot-scope="props">
                                        <td>

                                            <v-menu
                                                v-if="puedeResetPass || puedeVerExpediente"
                                                transition="scale-transition"
                                                origin="left top"
                                                bottom
                                                right
                                                slot="activator"
                                            >
                                                <v-btn class="ma-0" icon slot="activator">
                                                    <v-icon>more_vert</v-icon>
                                                </v-btn>
                                                <v-list class="app-card-action">
                                                    <v-list-tile 
                                                        v-if="puedeVerExpediente"
                                                        @click="$router.push('/personal/expediente/'+props.item._id)">
                                                        <i class="fa fa-folder orange--text mr-2 fs-14"></i>
                                                        <span>Expediente</span>
                                                    </v-list-tile>
                                                    <v-list-tile @click="activar(props.item._id)">
                                                        <i class="fa fa-user-edit blue--text mr-2 fs-14"></i>
                                                        <span>Modificar status</span>
                                                    </v-list-tile>
                                                    <v-list-tile 
                                                        v-if="puedeResetPass"
                                                        @click="resetPassAction(props.item._id)">
                                                        <i class="fa fa-key purple--text mr-2 fs-14"></i>
                                                        <span>Restablecer contraseña</span>
                                                    </v-list-tile>
                                                </v-list>
                                            </v-menu>

                                        </td>
                                        <td class="text-xs-left">{{ props.item.codigo }}</td>
                                        <td class="text-xs-left">{{ props.item.paterno }}</td>
                                        <td class="text-xs-left">{{ props.item.materno }}</td>
                                        <td class="text-xs-left">{{ props.item.nombre }}</td>
                                        <td class="text-xs-left">{{ props.item.laboral.dependencia }}</td>
                                        <td class="text-xs-left">{{ props.item.laboral.puesto }}</td>
                                        <td class="text-xs-left">{{props.item.status}}</td>
                                        

                                    </template>
                                </v-data-table>
                            </v-card>
													
                        </v-card-title>

                        <v-card-title v-if="puedeAgregar">
                            <v-tooltip top>
                                <v-btn fab dark small color="primary" slot="activator" @click="nuevoPersonal()">
                                    <v-icon dark>fa-user-plus</v-icon>
                                </v-btn>
                                <span>Agregar</span>
                            </v-tooltip>
                        </v-card-title>

                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>

        <reset-pass
            v-if="resetPass.mostrar"
            :id="resetPass.id"
            :mostrar="resetPass.mostrar"
            @cerrar="cerrarResetPass()"
            @enviandoStart="enviando=true"
            @enviandoStop="enviando=false"
        />

	</div>
</template>

<script>
import { mapGetters } from "vuex";
import Loader from '../../components/Loader'
import ResetPass from './resetPass'
import axios from 'axios'
import moment from 'moment'

export default {
	name: 'Personal',
	components: {
        Loader,
        ResetPass
	},
  computed: {
    ...mapGetters([
        "sessionToken",
        "httpURL",
        "userId",
        "tableProps",
        "permisos",
        "role"
      ]),
    puedeAgregar(){
        return this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 161) >= 0;
    },
    puedeResetPass(){
        return this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 162) >= 0;
    },
    puedeVerExpediente(){
        return this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 163) >= 0;
    },
  },
    data() {
        return {
            enviando:false,
            buscar:'',
			lista:{
				headers:[
                    { text: '', value: 'Options', sortable: false },
                    { text: 'Código', value: 'codigo' },
                    { text: 'Paterno', value: 'paterno' },
                    { text: 'Materno', value: 'materno' },
                    { text: 'Nombre', value: 'nombre' },
                    { text: 'Dependencia', value: 'dependencia' },
                    { text: 'Puesto', value: 'puesto' },
                    { text: 'Status', value: 'status' }
                ],
                data:[]
            },
            resetPass:{
                mostrar: false,
                id: null
            }
        }
	},
  created(){
      this.enviando = true;
      axios.get(this.httpURL+'/personal/listado',{headers:{token: this.sessionToken}})
        .then(res => {
            res.data.usuarios.forEach(element => {
                element.dependencia = element.dependencia ? element.dependencia : ''
                element.puesto = element.puesto ? element.puesto : ''
                element.status = element.status ? element.status : 'SIN ASIGNAR'
                this.lista.data.push(element);
            });
            this.enviando = false;
            this.$notify({ group: 'foo_notif', type:'success', duration:3500, text: res.data.mensaje});
        })
        .catch(error => {
            // console.log(error);
            this.enviando = false;
            this.$notify({ group: 'foo_notif', type:'error', duration:4000, text: error.response.data.mensaje});
        });
  },
  
	methods: {
        activar(id){
            this.enviando=true;
            axios.put(this.httpURL+'/personal/status/'+id,
                {},
                {headers:{token: this.sessionToken}
            })
            .then(res => {
                let index = this.lista.data.findIndex(x=>x._id ==id);
                if(index) this.lista.data[index].status = res.data.status;
                this.enviando = false;
                this.$notify({ group: 'foo_notif', type:'success', duration:3500, text: res.data.mensaje});
            })
            .catch(error => {
            // console.log(error);
            this.enviando = false;
            this.$notify({ group: 'foo_notif', type:'error', duration:4000, text: error.response.data.mensaje});
        });

        },
		nuevoPersonal(){
			this.$router.push('/personal/agregar');
        },
        calculaEdad(fecha){
            var birthday = moment(fecha);
            //console.log(birthday);
            var age = moment().diff(birthday,'years');
            if( age > 0 )
                return age === 1 ? age + ' año' : age + ' años';
            else{
                age = moment().diff(birthday,'months');
                return age === 1 ? age + ' mes' : age + ' meses';
            }
        },
        resetPassAction(id){
            this.resetPass.mostrar = true;
            this.resetPass.id = id;
        },
        cerrarResetPass(){
            this.resetPass.mostrar = false;
            this.resetPass.id = null;
        }
	}
};
</script>

<style>
    .alert-style{
        font-family: 'Heebo', sans-serif !important;
    }
</style>